import { Injectable, Optional, SkipSelf } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { AttributeGroupTypes } from 'ish-core/models/attribute-group/attribute-group.types';
import { Attribute } from 'ish-core/models/attribute/attribute.model';
import { ProductHelper } from 'ish-core/models/product/product.helper';

@Injectable()
export class ICSAProductContextFacade {
  constructor(@SkipSelf() @Optional() private context: ProductContextFacade) {}

  getMarketingLabels(): string[] | undefined {
    const marketingLabelAttribute = this.context
      .get('product')
      ?.attributeGroups?.PRODUCT_CUSTOM_ATTRIBUTES?.attributes?.find(
        attribute => attribute.name === 'Marketing Bug'
      )?.value;
    return marketingLabelAttribute
      ? (marketingLabelAttribute as string)
          .split(',')
          .filter(flag => flag === 'best' || flag === 'new' || flag === 'sale')
      : undefined;
  }

  getProductCustomAttribute$(): Observable<Attribute<string>[] | undefined> {
    return this.context
      .select('product')
      .pipe(
        map(
          product =>
            ProductHelper.getAttributesOfGroup(product, AttributeGroupTypes.ProductLabelAttributes) || undefined
        )
      ) as Observable<Attribute<string>[] | undefined>;
  }

  getMarketingAttribute$(): Observable<Attribute<string>> {
    return this.getProductCustomAttribute$().pipe(
      map(attributes => attributes?.find(attribute => attribute.name === 'Marketing Bug'))
    );
  }

  getMarketingLabels$(): Observable<string[]> {
    return this.getMarketingAttribute$().pipe(
      map(label => label?.value.split(',').filter(flag => flag === 'best' || flag === 'new' || flag === 'sale'))
    );
  }
}
